var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useNavigator } from '../hooks/useNavigator';
import { useAnalytics } from 'hx-analytics';
export var NavButton = function (_a) {
    var label = _a.label, type = _a.type, _b = _a.variant, variant = _b === void 0 ? 'contained' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, onClick = _a.onClick, analyticsEvent = _a.analyticsEvent, children = _a.children, _d = _a.firstOnMobile, firstOnMobile = _d === void 0 ? false : _d, navigateTo = _a.navigate, _e = _a.Component, Component = _e === void 0 ? Button : _e, delta = _a.delta, rest = __rest(_a, ["label", "type", "variant", "className", "onClick", "analyticsEvent", "children", "firstOnMobile", "navigate", "Component", "delta"]);
    var sendButtonClick = useAnalytics().sendButtonClick;
    var navigate = useNavigate();
    var _f = useNavigator(), next = _f.next, back = _f.back;
    var getOnClick = function () {
        if (navigateTo)
            return function () { return navigate(navigateTo); };
        if (delta)
            return function () { return navigate(delta); };
        if (type === 'back')
            return back;
        if (type === 'next')
            return next;
        return undefined;
    };
    function handleClick() {
        var _a;
        (_a = getOnClick()) === null || _a === void 0 ? void 0 : _a();
        if (typeof onClick !== 'undefined')
            onClick();
        if (!analyticsEvent)
            return;
        sendButtonClick(analyticsEvent);
    }
    return (_jsx(NavButtonRoot, __assign({ firstOnMobile: firstOnMobile, className: className, variant: variant, onClick: handleClick, type: type === 'submit' ? 'submit' : 'button' }, rest, { children: children || label || type })));
};
var NavButtonRoot = styled(Button, {
    shouldForwardProp: function (prop) { return prop !== 'firstOnMobile'; },
})(function (_a) {
    var _b;
    var theme = _a.theme, firstOnMobile = _a.firstOnMobile;
    return (__assign({ display: 'flex', flex: '1' }, (firstOnMobile && (_b = {},
        _b[theme.breakpoints.up('sm')] = {
            '&': {
                order: '9999',
            },
        },
        _b))));
});
